'use strict'

/**
 * サマリカード（設定済項目 / 参照可能ダッシュボード / 参照可能グラフ / 総数）。 純粋な表示コンポーネントで、派生値の summary / totals を props で受け取り、React.memo で props
 * が変わらない限り再レンダーしない。
 */

import React from 'react'
import PropTypes from 'prop-types'

/**
 * @param {{
 *   summary: { setCount: number; totalCount: number; referableDashboardCount: number; referableGraphCount: number }
 *   totals: { totalItems: number; totalDashboards: number; totalGraphs: number }
 * }} props
 * @returns {JSX.Element}
 */
function MatrixSummary({ summary, totals }) {
  return (
    <div className="status flex flex-wrap gap-3 mb-2">
      <div className="matrix-status-card">
        <div className="label text-[11px] text-gray-500">設定済項目</div>
        <div className="value text-base font-semibold mt-0.5">
          {summary.setCount} / {summary.totalCount}
        </div>
      </div>
      <div className="matrix-status-card">
        <div className="label text-[11px] text-gray-500">参照可能ダッシュボード</div>
        <div className="value text-base font-semibold mt-0.5">
          {summary.referableDashboardCount} / {totals.totalDashboards}
        </div>
      </div>
      <div className="matrix-status-card">
        <div className="label text-[11px] text-gray-500">参照可能グラフ</div>
        <div className="value text-base font-semibold mt-0.5">
          {summary.referableGraphCount} / {totals.totalGraphs}
        </div>
      </div>
      <div className="matrix-status-card">
        <div className="label text-[11px] text-gray-500">総項目 / 総ダッシュボード / 総グラフ</div>
        <div className="value text-base font-semibold mt-0.5">
          {totals.totalItems} / {totals.totalDashboards} / {totals.totalGraphs}
        </div>
      </div>
    </div>
  )
}

MatrixSummary.propTypes = {
  summary: PropTypes.object.isRequired,
  totals: PropTypes.object.isRequired
}

export default React.memo(MatrixSummary)
